module.exports = __webpack_public_path__ + "img/options-time-ext-guide.fc801baf.png";